<template>
    <div  v-loading="true" style="height:800px;width: 100%;">
    <h1>loading...</h1>
  </div>   
</template>

<script>
export default {
    mounted(){
        
    }
}
</script>


// WEBPACK FOOTER //
// src/views/nav1/loading.vue